<template>
    <div @click="handleClick" class="do-not-show-again-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
            <path d="M7.66667 1L1 7.66667M1 1L7.66667 7.66667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
</template>

<script setup>
const emit = defineEmits(['handleClick']);

const handleClick = () => {
    emit('handleClick');
};
</script>

<style scoped>
.do-not-show-again-icon {
    width: 20px;
    height: 20px;
    background-color:transparent;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.do-not-show-again-icon:hover {
    background-color: #305BF3;
    filter: drop-shadow(0 4px 4px #FFF);
    cursor: pointer;
}
</style>